import { post, get, put } from "../../../common/api-service";
import IDealership from "../interfaces/IDealership";

const DealerOnboardingAPI = {
    async DealerOnboarding(data: IDealership) {
        const url = `/dealer/onboarding`;
        return await post(url, data);
    },

    async GetAll() {
        const url = `/dealer/get-all`;
        return await get(url);
    },

    // DealerDetails
    async GetDealershipDetails(id: number) {
        const url = `/dealer/onboarding/details/${id}`;
        return await get(url);
    },

    // UpdateDealerDetails
    async UpdateDealershipDetails(data: IDealership) {
        const url = `/dealer`;
        return await put(url, data);
    },

    // GetDealershipStats
    async GetDealershipsStats() {
        const url = `/dealer/dealerships-stats`;
        return await get(url);
    },

    // Dealer GUID by URL name
    async GetDealershipGUID(dealershipUrl: string) {
        const url = `/dealer/get-id/${dealershipUrl}`;
        return await get(url);
    },

    async SyncDealershipExistingCustomersNames(dealershipId: number) {
        const url = `/customer/update-customers-names/${dealershipId}`;
        return await get(url);
    },
};

export default DealerOnboardingAPI;
